const PaymentLoading = ({ loading }) => {
  return (
    <>
      {loading && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex justify-center items-center p-4">
          <div className="bg-white rounded-2xl p-8 flex flex-col items-center shadow-2xl max-w-sm w-full relative transform transition-all duration-300 ease-out">
            {/* Animated Spinner */}
            <div className="relative">
              <div className="animate-spin h-16 w-16 border-4 border-blue-200 border-t-blue-600 rounded-full shadow-lg"></div>
              <div className="absolute inset-0 animate-pulse">
                <div className="h-16 w-16 bg-blue-100 rounded-full opacity-30 animate-ping"></div>
              </div>
            </div>

            {/* Loading Text */}
            <div className="mt-6 text-center">
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Opening Secure Payment
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Please wait while we connect you to Razorpay’s secure payment
                gateway...
              </p>
            </div>

            {/* Progress Dots */}
            <div className="flex space-x-1 mt-6">
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
              <div
                className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
                style={{ animationDelay: "0.1s" }}
              ></div>
              <div
                className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
                style={{ animationDelay: "0.2s" }}
              ></div>
            </div>

            {/* Tip / Warning */}
            <p className="mt-6 text-xs text-gray-500 text-center italic">
              Do not refresh or close this page during the process
            </p>

            {/* Decorative elements */}
            <div className="absolute -top-2 -right-2 w-4 h-4 bg-blue-200 rounded-full opacity-50"></div>
            <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-indigo-200 rounded-full opacity-40"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentLoading;
